"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertPromotionAmount = assertPromotionAmount;
exports.assertPromotionPercent = assertPromotionPercent;
const errors_1 = require("../errors");
const cents_1 = require("../money/cents");
// F4 (spec §7) : jamais d'échec silencieux sur l'argent. Une promotion mal
// formée doit faire échouer le calcul, pas produire une remise absurde.
function assertPromotionAmount(value, label) {
    (0, cents_1.assertCents)(value, label);
    if (value < 0) {
        throw new errors_1.InvalidAmountError(`${label} doit être positif ou nul, reçu : ${value}`);
    }
}
function assertPromotionPercent(value, label) {
    if (!Number.isFinite(value) || value < 0) {
        throw new errors_1.InvalidPercentError(`${label} doit être un pourcentage positif ou nul, reçu : ${value}`);
    }
}
